import {
  Permission,
  RFIStatus,
  SharePointParentFolder,
} from '@cims-online/shared'
import { CustomRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { useRFITrackerContext } from '../../../../RFITrackerContext'
import {
  useLockRowActionButton,
  useUnlockRowActionButton,
} from 'components/CIMSTable/common/hooks/useLockUnlock'
import { useClosedDisabledMessage } from 'components/CIMSTable/common/hooks/useClosedDisabledMessage'
import { RequestForInformation } from '../../../../RFITrackerContext/types'

export function useCustomRowOptions(): CustomRowActionOptions<RequestForInformation>[] {
  const {
    refetch,
    revertRFIModal: { toggle },
  } = useRFITrackerContext()
  const lock = useLockRowActionButton<RequestForInformation>({
    refetch,
    parent: SharePointParentFolder.RequestForInformation,
    hidden: ({ statusId, deleted }) =>
      deleted || statusId !== RFIStatus.Unlocked.id,
  })
  const unlock = useUnlockRowActionButton<RequestForInformation>({
    refetch,
    parent: SharePointParentFolder.RequestForInformation,
    hidden: ({ statusId, deleted }) =>
      deleted || statusId !== RFIStatus.Closed.id,
  })
  return [
    {
      text: 'Revert',
      permission: Permission.RevertRequestForInformation,
      onClick: (record) => toggle(record),
      disabled: useClosedDisabledMessage('reverted', RFIStatus.Closed),
      hidden: ({ statusId, deleted }) =>
        statusId === RFIStatus.Draft.id || deleted,
    },
    lock,
    unlock,
  ]
}
